import React, { useState } from 'react';
import './WhatsAppChat.css';

const WhatsAppChat = () => {
    const [linkClicked, setLinkClicked] = useState(false);

    const handleClick = () => {
        setLinkClicked(true);
        window.open(
            'https://wa.me/918576891104?text=Hi%20there!%20I%20want%20to%20schedule%20a%20meeting',
            '_blank',
            'noopener,noreferrer'
        );
    };

    return (
        <div className="whatsapp-float" onClick={handleClick} role="button">
            {!linkClicked && (
                <>
                    <img
                        src="https://cdn-icons-png.flaticon.com/512/733/733585.png"
                        alt="WhatsApp Chat"
                        className="whatsapp-icon"
                        loading="lazy"
                    />
                    <h3 className="whatsapp-label">Live Chat</h3>
                </>
            )}
        </div>
    );
};

export default WhatsAppChat;
